import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import api from "../lib/api";
import { toast } from "sonner";
import { Loader2, Mail, ArrowLeft, X } from "lucide-react";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Email envoyé si un compte existe");
    } catch {
      toast.error("Erreur, réessayez");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12" data-testid="forgot-page">
      <div className="w-full max-w-md card-soft p-8 sm:p-10 relative">
        <button
          type="button"
          onClick={() => navigate("/")}
          className="absolute top-4 right-4 h-9 w-9 rounded-full hover:bg-secondary flex items-center justify-center text-muted-foreground hover:text-foreground transition"
          aria-label="Fermer"
          data-testid="forgot-close"
        >
          <X className="h-5 w-5" />
        </button>
        <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground inline-flex items-center mb-6">
          <ArrowLeft className="h-4 w-4 mr-1" /> Retour
        </Link>
        <div className="flex justify-center mb-6">
          <img src="https://customer-assets.emergentagent.com/job_fundcollect-1/artifacts/z3sp2s14_logo-sen-cagnotte-1.png" alt="Sen Cagnotte" className="h-16 w-16 rounded-2xl object-cover" />
        </div>
        <h1 className="font-display text-3xl font-bold text-center mb-2">Mot de passe oublié ?</h1>
        <p className="text-center text-muted-foreground mb-8 text-sm">Pas de panique. Entrez votre email pour recevoir un lien.</p>

        {sent ? (
          <div className="text-center py-6 px-4 rounded-2xl bg-emerald-50 dark:bg-emerald-950/30 border border-emerald-200 dark:border-emerald-900">
            <p className="text-sm text-emerald-800 dark:text-emerald-200">Si un compte existe pour <strong>{email}</strong>, un email a été envoyé.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="pl-10 h-11 rounded-xl" data-testid="forgot-email" />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full btn-gradient rounded-full h-11" data-testid="forgot-submit">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Envoyer le lien"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
